import { dataSource } from "../../../framework";
import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_Input from "../templates/K_Input";
import { ComponentOptions } from "./component";
import { InputOptions } from "./input";
import { TemplateComponent } from "./templateComponent";

export interface DropDownListOptions extends InputOptions, kendo.ui.DropDownListOptions {
    bindNumberValue?: string;
    readOnly?: boolean;
    width?: number | string;
    url?: string;
    preFilter?: string;
    bindClass?: string;
}

export class DropDownList extends TemplateComponent {

    options: DropDownListOptions;

    constructor(options: DropDownListOptions) {
        super(K_Input, options);
    }

    preRender() {
        const options = this.options;

        // Set defaults for woop fields
        if (options.labelAbove) {
            options.bsc = options.bsc || " ";
            if (options.valueWidth) {
                options.containerWidth = options.containerWidth || +options.valueWidth + 10;
                options.labelWidth = options.labelWidth || options.valueWidth;
            }
            options.labelAbove = buildDataBindSyntax(options.labelAbove, "text");
        }

        options.label = buildDataBindSyntax(options.label, "text");
        options.required = options.required || false;
        options.readOnly = options.readOnly || false;
        options.bindValue = buildDataBindSyntax(options.bindValue, "input");
        options.bindNumberValue = buildDataBindSyntax(options.bindNumberValue, "text");
        options.containerClasses = options.containerClasses || "";
        options.containerBind = buildDataBindSyntax(options.containerBind, "container");
        options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
        options.labelBsc = options.labelBsc || "col-xs-5";
        options.inputBsc = options.inputBsc || "col-xs-7  no-pad";
        options.iconType = options.iconType || "";
        options.iconId = options.iconId || "";
        options.iconClasses = options.iconClasses || "";
        options.iconInput = options.iconType ? "icon-input" : "";
        options.width = options.width;
    }

    create() {
        if (this.options.infoTooltip || this.options.infoTooltipContent) {
            toolTip({
                alignX: "center",
                alignY: "top",
                alignTo: "target",
                offsetY: 5,
                selector: $(`#${this.id}_info`),
                content: this.options.infoTooltip
                    ? ll(this.options.infoTooltip)
                    : this.options.infoTooltipContent
            });
        }

        const options = this.options;

        options.change = options.change || function (e) {
            if (!this.current()) {
                this.value("");
            }
        };

        if (!options.dataSource && options.url) {
            var ds = dataSource({
                transport: {
                    read: {
                        url: options.url,
                        contentType: "application/json",
                        dataType: "json"
                    },
                    parameterMap: function (data, type) {
                        var params: any = { $inlinecount: "allpages" };
                        var filterExpression = "";

                        if (options.preFilter) {
                            filterExpression += options.preFilter;
                        }

                        if (filterExpression != "") {
                            params.$filter = filterExpression;
                        }

                        return params;
                    }
                }
            });

            options.dataSource = ds;
        }

        var dropdown = $(`#${this.id}`).kendoDropDownList(options).data("kendoDropDownList");
        if (options.width) {
            dropdown.list.width(options.width);
        }

        if (options.readOnly && dropdown) {
            (dropdown as any).readOnly(true);
        }

    }

}
